import ClipBoard from './ClipBoardContainer';
export default ClipBoard;
